/**
 * Fix accessibility issues for third-party elements
 * - Remove aria-hidden from focusable third-party elements
 * - Add accessible names to buttons and links that lack them
 */
(function() {
  function fixVenturaFieldAccessibility() {
    const venturaField = document.getElementById('ventura-field-comments');
    if (venturaField && venturaField.hasAttribute('aria-hidden')) {
      // Remove aria-hidden from focusable elements to fix accessibility violation
      venturaField.removeAttribute('aria-hidden');
    }
  }

  function fixOwlCarouselButtons() {
    // Fix Owl Carousel navigation buttons
    const prevButtons = document.querySelectorAll('button.owl-prev');
    const nextButtons = document.querySelectorAll('button.owl-next');
    
    prevButtons.forEach(function(button) {
      // Remove role="presentation" which hides the button from screen readers
      if (button.getAttribute('role') === 'presentation') {
        button.removeAttribute('role');
      }
      // Always ensure the button has an aria-label (check inner span first, then add default)
      if (!button.getAttribute('aria-label')) {
        const innerSpan = button.querySelector('span[aria-label]');
        if (innerSpan && innerSpan.getAttribute('aria-label')) {
          button.setAttribute('aria-label', innerSpan.getAttribute('aria-label') + ' slide');
        } else {
          button.setAttribute('aria-label', 'Previous slide');
        }
      }
    });
    
    nextButtons.forEach(function(button) {
      // Remove role="presentation" which hides the button from screen readers
      if (button.getAttribute('role') === 'presentation') {
        button.removeAttribute('role');
      }
      // Always ensure the button has an aria-label (check inner span first, then add default)
      if (!button.getAttribute('aria-label')) {
        const innerSpan = button.querySelector('span[aria-label]');
        if (innerSpan && innerSpan.getAttribute('aria-label')) {
          button.setAttribute('aria-label', innerSpan.getAttribute('aria-label') + ' slide');
        } else {
          button.setAttribute('aria-label', 'Next slide');
        }
      }
    });
  }

  function fixWishlistLink() {
    // Fix HulkApps wishlist drawer link
    const wishlistLink = document.querySelector('a.hulk-wl-header-icon.hulk-wishlist-drawer');
    if (wishlistLink) {
      // Check if it already has accessible text
      const hasText = wishlistLink.textContent.trim() || wishlistLink.getAttribute('aria-label');
      if (!hasText) {
        wishlistLink.setAttribute('aria-label', 'Open wishlist');
      }
    }
  }

  function fixAllAccessibilityIssues() {
    fixVenturaFieldAccessibility();
    fixOwlCarouselButtons();
    fixWishlistLink();
  }

  // Fix on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      fixAllAccessibilityIssues();
      // Also run after a short delay to catch carousel initialization
      setTimeout(fixAllAccessibilityIssues, 500);
      setTimeout(fixAllAccessibilityIssues, 1000);
    });
  } else {
    fixAllAccessibilityIssues();
    // Also run after a short delay to catch carousel initialization
    setTimeout(fixAllAccessibilityIssues, 500);
    setTimeout(fixAllAccessibilityIssues, 1000);
  }

  // Use MutationObserver to catch dynamically added elements
  const observer = new MutationObserver(function(mutations) {
    fixAllAccessibilityIssues();
  });

  // Start observing when DOM is ready
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
})();
